import dayjs from "dayjs";
import * as satellite from "satellite.js";

export const EARTH_RADIUS_KM = 6371;
export type PathPoint = [number, number, number];

export const getOrbitPosition = (
  satrec: satellite.SatRec,
  timestamp: number,
): PathPoint | null => {
  const date = dayjs(timestamp).toDate();
  const result = satellite.propagate(satrec, date);
  if (!result?.position) return null;

  const position = satellite.eciToGeodetic(
    result.position,
    satellite.gstime(date),
  );
  const point: PathPoint = [
    satellite.degreesLat(position.latitude),
    satellite.degreesLong(position.longitude),
    position.height / EARTH_RADIUS_KM,
  ];
  if (!point.every(Number.isFinite) || point[2] <= 0) return null;
  return point;
};

export const generateFutureOrbit = (
  satrec: satellite.SatRec,
  timestamp: number,
  durationMinutes = 45,
  resolution = 120,
  startGapSeconds = 60,
): PathPoint[] => {
  if (resolution < 1 || durationMinutes * 60 <= startGapSeconds) return [];
  const points: PathPoint[] = [];
  const durationSeconds = durationMinutes * 60 - startGapSeconds;
  for (let index = 0; index <= resolution; index++) {
    const offsetSeconds =
      startGapSeconds + (index / resolution) * durationSeconds;
    const position = getOrbitPosition(satrec, timestamp + offsetSeconds * 1000);
    if (!position) return [];
    points.push(position);
  }
  return points;
};

export const toGlobeCoordinates = (
  [lat, lng, altitude]: PathPoint,
  radius: number,
): [number, number, number] => {
  const latitude = (lat * Math.PI) / 180;
  const longitude = (lng * Math.PI) / 180;
  const distance = radius * (1 + altitude);
  return [
    distance * Math.cos(latitude) * Math.sin(longitude),
    distance * Math.sin(latitude),
    distance * Math.cos(latitude) * Math.cos(longitude),
  ];
};
